export const DEFAULT_MAP_CENTER: [number, number] = [10.7769, 106.7009];
